export { EnvVarsRuntimeContent } from './EnvVarsRuntimeContent';

import { Entity } from '@backstage/catalog-model';

export const isEnvVarsRuntimeAvailable = (entity: Entity) =>
  Boolean(entity.metadata.annotations?.['backstage.io/kubernetes-id']);
